export default __webpack_public_path__ + "static/media/dermal-fillers.d6c0c2a6.JPG";